import { Divider } from '@mui/material';

function SectionDivider() {
  return (
    <Divider
      color="#F2F2F2"
      variant="fullWidth"
      component="div"
      sx={{
        borderColor: '#F2F2F2',
        p: 0,
        marginY: 5,
      }}
    />
  );
}

export default SectionDivider;
